/**
 * Local durability layer for bookmark state, keyed by problem slug.
 * Not a source of truth (the server is) — just lets an optimistic toggle
 * survive a reload/offline gap while a request is in flight, and lets list
 * views reflect a just-made change instantly without waiting on a refetch.
 */
const STORAGE_KEY = "ch_bookmark_cache_v1";

const readCache = () => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
};

const writeCache = (cache) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(cache));
  } catch {
    /* ignore quota / private mode */
  }
};

/** Returns true/false if cached, or null if this slug has no cached state. */
export const getCachedBookmark = (slug) => {
  if (!slug) return null;
  const cache = readCache();
  return Object.prototype.hasOwnProperty.call(cache, slug) ? cache[slug] : null;
};

export const setCachedBookmark = (slug, isBookmarked) => {
  if (!slug) return;
  const cache = readCache();
  cache[slug] = !!isBookmarked;
  writeCache(cache);
};
